module.exports = __webpack_public_path__ + "assets/wheel-lamp.d6d6ce16859ff2dfd66761956ac76472.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wheel-lamp.png
// module id = 49
// module chunks = 0